import React from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { Checkbox } from 'antd'
import PropTypes from 'prop-types'

const CheckboxWithHotKey = ({
  hotkey,
  hotkeyEnabled,
  isChecked,
  onChange,
  isDisabled,
}) => {
  useHotkeys(hotkey, onChange, { enabled: hotkeyEnabled }, [
    hotkey,
    onChange,
    hotkeyEnabled,
  ])

  return (
    <Checkbox checked={isChecked} onChange={onChange} disabled={isDisabled} />
  )
}

CheckboxWithHotKey.propTypes = {
  hotkey: PropTypes.string.isRequired,
  hotkeyEnabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
}

CheckboxWithHotKey.defaultProps = {
  hotkeyEnabled: true,
  isChecked: false,
  isDisabled: false,
}

export default CheckboxWithHotKey
